import React, { useEffect, useRef, useState} from "react";
import Loading, { UploadLoading } from "components/Loading";
import {
    EllipsisTextColumn,
    FlexGrow,
    ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {
    ClassAddStudentType,
    ClassInfo,
    ClassQueryParams,
    ClassRequestType, colorList,
    ColorType, CommonResult, defaultColor,
    ExcelMoveClassStudentInfo,
    ListResult,
    provinceInfo,
    SingleResult, StudentInfo, StudentQueryParams,
    UserInfo
} from "../../type/type";
import {NoDataWithImageText, NoDataWithImageTextButton} from "components/NoDataComponent";
import {NoLinePrimaryBtn, OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn, SolidRedBtn} from "components/button/Button";
import styled from "styled-components";
import * as XLSX from "xlsx";
import {
    addStudentToClassHandler,
    createClassHandler,
    getClass,
    getImageUrl,
    getStudent,
    getUser,
    removeClassHandler,
    updateClassHandler,
    updateStudentClassExcelHandler
} from "../../api/api";
import {
    aesCBCDecrypt,
    ellipsisText,
    formattedSelectOption,
    NoClassDataText,
    NoStudentDataText,
    NoTeamClassDataText,
    ROLE_DIRECTOR,
    ROLE_TEACHER,
} from "../../utils/commonUtils";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import {CustomCheckbox, SelectOption} from "components/input/Input";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import {RoundBigImage, RoundImage, RoundImageContainer} from "components/common/Image";
import { FlexWrapC, FlexWrapR, InputWrapC, InputWrapR } from "components/common/CommonLayout";
import {useLoginUserInfo} from "../../redux/hook/useLoginUserInfo";
import { useRecoilValue } from "recoil";
import { selectSiteIdState, userRoleState } from "styles/atoms";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { colors } from "styles/global-styles";
import { RoundIcon } from "components/common/Icon";

const TableColumn = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;

const TableColumnStudent = styled(TableColumn)<{isSelected:boolean}>`
    background-color: ${({ isSelected, theme }) =>
        isSelected ? theme.newTheme.table.tableBodyHoverBg : 'transparent'}; // 선택된 경우 배경색 변경
    &:hover {
        cursor: pointer;
    }
`

const InputWrap = styled.div`
  width: 100%;
  display: flex;
`;

const NoDataWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const ColorListWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding:0.8rem;
`

// 색상을 props로 받는 타원 컴포넌트
const CircleBadge = styled.div<{ bgColor: ColorType }>`
    margin-right:0.5rem;
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.bgColor}; /* 색상을 props로 설정 */
    border-radius: 100px;       /* 타원 모양을 만들기 위해 반경 설정 */
`;

const CircleListBadge = styled.div<{ bgColor: ColorType; checked?:boolean }>`
    cursor: pointer;
    margin-right:0.5rem;
    width: 18px;
    height: 18px;
    background-color: ${(props) => props.bgColor}; 
    border-radius: 100px;
    position: relative;
    border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
    
    &::after {
        content: '';
        display: ${(props) => (props.checked ? 'block' : 'none')};
        width: 10px;
        height: 10px;
        background-image: url('/image/icon/color_check.png');  /* 이미지 경로 */
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}`;

const UploadingComponent = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
`;

const UploadBtn = styled.div`

    label {
        padding: 0.625rem 1.25rem;
        display: inline-block;
        background-color: ${({theme}) => theme.newTheme.textField.defaultBg};
        border-radius: 0.5rem;
        margin-right: 0.5rem;
        &:hover {
            cursor: pointer;
            background-color: ${({theme}) => theme.newTheme.textField.disabledBg};
        }
    }
`;

interface ClassListViewerProps {
    classList:ClassInfo[];
    openModal:(modalType:ModalType) => void;
    changeRequestClassHandler: (id: number, name: string, classInfo: ClassInfo) => void;
    handleDeleteClass: (classId:number) => void;
}

//반 목록 테이블 리스트
const ClassListTableViewer:React.FC<ClassListViewerProps> = ({classList, openModal,changeRequestClassHandler,handleDeleteClass}) => {

    return (

        <div className="list-one-wrap h100">
            <div className="list-table">
                <div>
                    <nav className="list-table-header">
                        <div className="w-8">번호</div>
                        <FlexGrow className="w-20">반 이름</FlexGrow>
                        <FlexGrow className="w-15">반 소개</FlexGrow>
                        <FlexGrow className="w-15">반 소개 내용</FlexGrow>
                        <FlexGrow className="w-12">담당 선생님</FlexGrow>
                        <div className="w-15">학생 수</div>
                        <div className="w-12"></div>
                    </nav>

                    {classList.map((classInfo: ClassInfo, index) => {
                        return (
                            <TableColumn key={classInfo.id}>
                                <div className="w-8">{index+1}</div>
                                <FlexGrow className="w-20">
                                    <CircleBadge bgColor={classInfo.color_type} />
                                    <EllipsisTextColumn style={{maxWidth: 'calc(100% - 20px)'}}>{classInfo.name}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-15">
                                    <EllipsisTextColumn>{ellipsisText(classInfo.title,10)}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-15">
                                    <EllipsisTextColumn>{ellipsisText(classInfo.content,10)}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-12">
                                    <EllipsisTextColumn>{classInfo.user_name ? aesCBCDecrypt(classInfo.user_name) : ""}</EllipsisTextColumn>
                                </FlexGrow>
                                <div className="w-15" style={{justifyContent: 'end'}}>
                                    <div><span>{classInfo.student_list.length}명</span></div>
                                    <div style={{marginLeft:'10px'}}>
                                        <OutlinePrimaryBtn type="button" className="little-btn" onClick={() => {openModal('addStudent');changeRequestClassHandler(classInfo.id,classInfo.name,classInfo);}}>
                                            학생추가/수정
                                        </OutlinePrimaryBtn>
                                    </div>
                                </div>
                                <div className="w-12">
                                    <FlexWrapR>
                                        <OutlinePrimaryBtn type="button"
                                                            className="little-btn"
                                                            onClick={() => {
                                                                openModal('classModify');
                                                                changeRequestClassHandler(classInfo.id, classInfo.name, classInfo);
                                                            }}>
                                            수정
                                        </OutlinePrimaryBtn>
                                        <SolidRedBtn type="button" className="little-btn" onClick={() => { handleDeleteClass(classInfo.id); }}>
                                            삭제
                                        </SolidRedBtn>
                                    </FlexWrapR>
                                </div>
                            </TableColumn>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

/**
 * 반 일괄 이동 excel Header
 * "이름", "고유번호", "학부모 명", "기존 반", "이동 반"
 */
const excelHeaders = ["이름", "고유번호", "학부모 명", "기존 반", "이동 반"];

export const ClassManagement = () => {

    // 전역 데이터
    const { access, user } = useLoginUserInfo();
    const { user_id } = access;
    const { name } = user;
    const user_role = useRecoilValue(userRoleState);
    const selectSiteId = useRecoilValue(selectSiteIdState);

    const excelInputRef = useRef<HTMLInputElement>(null);

    const [loading, setLoading] = useState<boolean>(true);
    const [studentLoading, setStudentLoading] = useState<boolean>(true);

    //반 목록
    const [classList, setClassList] = useState<ClassInfo[]>([]);

    //선생님 셀렉트박스 option
    const [selectOptionTeachers, setSelectOptionTeachers] = useState<provinceInfo[]>([]);

    //학생 목록
    const [studentsWithImages, setStudentsWithImages] = useState<(StudentInfo & { image: string })[]>([]);

    //수정하기 클릭 시 해당 반의 id
    const [classClickId, setClassClickId] = useState<number>(0);
    const [classClickName, setClassClickName] = useState<string>("");

    // 엑셀파일
    const [excelFile, setExcelFile] = useState<File | null>(null);
    // 엑셀파일에 있는 데이터(사용자가 작성한 데이터)
    const [excelMoveClassList, setExcelMoveClassList] = useState<(ExcelMoveClassStudentInfo & { exist_class: boolean })[]>([]); // 보여주기용
    const [moveClassList, setMoveClassList] = useState<{ id: number, student_ids: number[] }[]>([]); // API용
    const [uploadExcelFileName, setUploadExcelFileName] = useState("");

    const [isUpload, setIsUpload] = useState(false);

    // 반 일괄 이동 성공 여부 / 's' 성공, 'f' 실패
    const [successMoveClass, setSuccessMoveClass] = useState<string[]>([]);

    //학생 목록 가져오기 시 필요한 파라미터
    const [studentRequestParams, ] = useState<StudentQueryParams>({
        page: 1,
        size: 1000,
        name: "",
        user_id: 0,
        class_id: 0
    })

    //반 등록/수정 시 입력한 정보 초기값
    const [requestClass, setRequestClass] = useState<ClassRequestType>({
        site_id: selectSiteId,
        user_id: user_role === ROLE_DIRECTOR ? 0 : user_id,
        name: "",
        logo_type: 0,
        color_type: defaultColor,
        title: "",
        content: "",
        student_ids: []
    });

    //선택된 학생 목록 (원생 추가 시 사용)
    const [selectedStudentIdList, setSelectedStudentIdList] = useState<ClassAddStudentType>({
        student_ids:requestClass.student_ids
    });

    //모달 상태
    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    //신규 반 등록 버튼 클릭 시 값 초기화
    function initRequestClass(){
        setRequestClass({
            site_id:selectSiteId,
            user_id:0,
            name:"",
            logo_type:0,
            color_type:defaultColor,
            title:"",
            content:"",
            student_ids:[]
        });
    }

    //반 일괄 이동 버튼 클릭 시 값 초기화
    function initExcel() {
        getStudentList();
        setUploadExcelFileName("");
        setExcelMoveClassList([]);
        setMoveClassList([]);
        setExcelFile(null);
    }

    //반 수정하기 클릭 시 requestClass에 해당 반 정보 저장
    function changeRequestClassHandler(classId:number,className:string,classInfo:ClassInfo){
        //클릭한 반의 정보 저장
        setClassClickId(classId);
        setClassClickName(className);
        setRequestClass({
            site_id:selectSiteId,
            user_id:classInfo.user_id,
            name:classInfo.name,
            logo_type:classInfo.logo_type,
            color_type:classInfo.color_type,
            title:classInfo.title,
            content:classInfo.content,
            student_ids:classInfo.student_list.map((student) => student.id)
        });
        //반에 속한 학생들 선택
        setSelectedStudentIdList({
            student_ids:classInfo.student_list.map((student) => student.id)
        });
        getStudentList();
    }


    // 반 목록 가져오기
    const getClassList = async () => {
        try {
            
            // 담당반 클래스 아이디 리스트 업데이트
            const classQueryParams: ClassQueryParams = {
                name: "",
                user_id: user_role === ROLE_DIRECTOR ? 0 : user_id,
                response_format: "",
                page: 1,
                size: 99999999
            };
        
            const classResult: ListResult<ClassInfo> = await getClass(classQueryParams);
        
            // 반 정보가 없는 경우
            if (classResult.code !== 200 || (classResult.code === 200 && classResult.data.length === 0)) {
                setClassList([]);
            }
            else {
                const userClassList: ClassInfo[] = classResult.data;
                setClassList(userClassList);

                const _classId = user_role === ROLE_DIRECTOR ? 0 : userClassList.length ? userClassList[0].id : -1;

                if (user_role === ROLE_TEACHER) setClassClickId(_classId);
            }

            getStudentList();

            if (user_role === ROLE_DIRECTOR) getTeacherList();

        } catch (error) {
            console.error("api error ", error);
        }
        finally {
            setLoading(false);
        }
    
    };

    //선생님 목록 가져오기 (select box)
    const getTeacherList = async () => {
        try {
            const res: ListResult<UserInfo> = await getUser({ site_id: selectSiteId });
            if (res.code === 200) {
                
                const teacherList = res.data.filter((user) => user.role === ROLE_TEACHER);
                const teacherSelectOption = formattedSelectOption(teacherList.map(teacher => ({
                    label: aesCBCDecrypt(teacher.name),
                    value: teacher.id
                })), '미지정');

                setSelectOptionTeachers(teacherSelectOption);

            }
        } catch (e) {
            console.error(e);
        }
    }

    const getStudentList = async () => {
        try {

            const res:ListResult<StudentInfo> = await getStudent(studentRequestParams);
            if(res.code === 200){
                const students:StudentInfo[] = res.data.filter((student) => {
                    return student.is_delete === 0;
                });

                //모든 학생 이미지 파일 가져오기
                const fetchImages = async () => {
                    if (user_role === ROLE_DIRECTOR) {
                        const studentsWithImagePromises = students.map(async (student: StudentInfo) => {
                            const image = (student.image_list.length > 0 && student.image_list[0].file_size) ? getImageUrl(student.image_list[0].file_name) : DefaultProfileS;
                            return { ...student, image };
                        });
    
                        const studentsWithImages = await Promise.all(studentsWithImagePromises);
                        setStudentsWithImages(studentsWithImages);
                    }
                    else {
                        const studentsWithImagePromises = students.filter(s => {
                            return s.class_list.length === 0 || s.class_list.some(c => c.id === classClickId);
                        })
                        .map(async (student: StudentInfo) => {
                            const image = (student.image_list.length > 0 && student.image_list[0].file_size) ? getImageUrl(student.image_list[0].file_name) : DefaultProfileS;
                            return { ...student, image };
                        });
    
                        const studentsWithImages = await Promise.all(studentsWithImagePromises);
                        setStudentsWithImages(studentsWithImages);
                    }
                };

                await fetchImages();

            }

        }
        catch (e) {
            console.error(e);
        }
        finally {
            setStudentLoading(false);
        }
    }


    //반 등록/수정 모달 열기 버튼 클릭 시
    const openModal = (modalType:ModalType) => {
        let title: ModalTitle = "";
        let content: JSX.Element = <></>;
        let button: JSX.Element = <></>;
        
        switch (modalType) {
            case "classCreate":
                title = "반 신규 등록";
                break;
            case "classModify":
                title = "반 정보 수정";
                break;
            case "addStudent":
                title = "학생 추가";
                break;
            case "excelMoveClass":
                title = "반 일괄 이동";
                break;
        }

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }

    // 등록/수정 완료 버튼 클릭 시
    async function validateClassForm() {

        // 이미 등록된 선생님인지 확인
        const userClass = classList.filter((c: ClassInfo) => c.user_id === requestClass.user_id);
        if (userClass.length && userClass[0].user_id !== 0 && userClass[0].id !== classClickId) {
            alert("이미 반이 등록된 선생님입니다. 다른 선생님을 지정해주세요");
            return;
        } 

        if(requestClass.name === "") {
            alert("반 이름을 입력해주세요.");
            return;
        }

        const classNameList = classList.map((c: ClassInfo) => c.name);
        
        // 신규 등록일 때 기존에 등록한 반이 있는지 체크
        if (modalProps.type === "classCreate") {
            const isSameName = classNameList.includes(requestClass.name); // 정확한 이름이 있는 경우
            if (isSameName) {
                alert("이미 등록된 반 이름입니다.");
                return;
            }
        }
        // 반 수정 시 id와 반 이름이 같은지 체크
        else {
            const isSameNameClass = classList.filter((c: ClassInfo) => c.name === requestClass.name); // 정확한 이름이 있는 경우
            if (isSameNameClass.length && isSameNameClass[0].id !== classClickId) {
                alert("이미 등록된 반 이름입니다.");
                return;
            }
        }

        // 반 수정 시 기존에 있는 반과 비슷한 이름으로 수정 했을 때
        let isCreateClass = true;
        if (!(modalProps.type === "classModify" && requestClass.name === classClickName)) {

            // 띄어쓰기를 제외하면 반 이름이 일치하는 경우
            let similar_class_name = "";
            classNameList.some((name: string, index: number) => {
                let result = name.replaceAll(" ", "") === requestClass.name.replaceAll(" ", "");
                if (result) similar_class_name = classNameList[index];
                return result;
            });
    
            if (similar_class_name) {
                isCreateClass =
                    window.confirm(`입력하신 반과 비슷한 [${similar_class_name}]은 이미 등록되어 있습니다. 그래도 등록하시겠습니까?`);
            }
            
        }

        if (!isCreateClass) return;

        modalProps.type === "classCreate" ? await createClass() : await updateClass();
        // 신규 반 등록
        async function createClass(){
            try {

                const res:SingleResult<any> = await createClassHandler(requestClass);
                if (res.code === 200) {
                    alert("반 등록이 완료되었습니다.");
                    setModalProps({...modalProps, isOpen: false});
                    getClassList();
                }
            } catch (e) {
                console.error(e);
            }
        }

        // 반 수정정
        async function updateClass(){
            try{

                const res:SingleResult<any> = await updateClassHandler(classClickId, requestClass);
                if (res.code === 200) {
                    alert("반 수정이 완료되었습니다.");
                    getClassList();
                    setModalProps({...modalProps, isOpen: false});
                }

            }
            catch (e) {
                console.error(e);
            }
        }
        
    }

    //테이블 행 클릭 시 학생 선택
    const handleStudentClick = (studentId: number) => {
        if (selectedStudentIdList.student_ids.includes(studentId)) {
            setSelectedStudentIdList({
                student_ids: selectedStudentIdList.student_ids.filter((id:number) => id !== studentId)
            });
        }
        else {
            setSelectedStudentIdList({
                student_ids: [...selectedStudentIdList.student_ids, studentId]
            });
        }
    };

    //모든 학생 체크 이벤트
    const handleAllStudentCheck = ():void => {

        if(selectedStudentIdList.student_ids.length === studentsWithImages.length){
            setSelectedStudentIdList({
                student_ids: []
            });
        }
        else{
            setSelectedStudentIdList({
                student_ids: studentsWithImages.map((student) => student.id)
            });
        }
    }

    //원생 추가 모달 컨텐츠
    const AddStudentModalContent = (): JSX.Element => {
        //리로드 시 체크박스 동기화
        const copyAllStudentCheck:boolean = selectedStudentIdList.student_ids.length === studentsWithImages.length;
        return (
            <div className="modal-list-table">
                <nav className="modal-list-table-header">
                    <div className="w-10">
                        <CustomCheckbox type="checkbox"
                                        checked={copyAllStudentCheck}
                                        onClick={handleAllStudentCheck} />
                    </div>
                    <div className="w-15">사진</div>
                    <FlexGrow className="w-30">이름</FlexGrow>
                    <FlexGrow className="w-25">등록된 반</FlexGrow>
                </nav>

                {/*//학생 목록 테이블 리스트*/}
                { studentLoading ? <Loading /> :
                    studentsWithImages.length ?
                        studentsWithImages
                            .sort((n, c) => {
                                const nextInClass = selectedStudentIdList.student_ids.includes(n.id);
                                const currentInClass = selectedStudentIdList.student_ids.includes(c.id);
                                const nHasClass = n.class_list.length > 0;
                                const cHasClass = c.class_list.length > 0;

                                // 1. 선택한 반에 있는 학생
                                if (nextInClass && !currentInClass) return -1;
                                if (!nextInClass && currentInClass) return 1;

                                // 2. 반 미정인 학생
                                if (!nHasClass && cHasClass) return -1;
                                if (nHasClass && !cHasClass) return 1;

                                // 3. 다른 반 학생들은 반 ID로 정렬
                                if (nHasClass && cHasClass) {
                                    return n.class_list[0].id - c.class_list[0].id;
                                }
                                
                                return 0; // 순서 유지
                            })
                            .map((student: StudentInfo & { image: string }, index) => (
                            <TableColumnStudent key={student.id}
                                                onClick={() => handleStudentClick(student.id)}
                                                isSelected={selectedStudentIdList.student_ids.includes(student.id)}>
                                <div className="w-10">
                                    <CustomCheckbox type="checkbox" checked={selectedStudentIdList.student_ids.includes(student.id)}/>
                                </div>
                                <div className="w-15">
                                    <RoundImage srcSet={student.image} alt="profile"/>
                                </div>
                                <FlexGrow className="w-30">
                                    <EllipsisTextColumn>{aesCBCDecrypt(student.name)}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className={`w-25 ${student.class_list.length ? "" : "text-red"} ${selectedStudentIdList.student_ids.includes(student.id) &&
                                                                                                                                student.class_list.length && classClickName !== student.class_list[0].name ? "text-green" : ""}`}>
                                    <EllipsisTextColumn>{student.class_list.length ? student.class_list[0].name : "반 미정"}</EllipsisTextColumn>
                                </FlexGrow>
                            </TableColumnStudent>
                        )) :
                        <div style={{marginTop: '1rem'}}>
                            <NoDataWithImageTextButton text={NoStudentDataText} btnText="학생 등록하기" linkUrl="/setting/studentManagement" />
                        </div>
                }
            </div>
        );
    }
    
    //학생 추가 모달 하단 버튼
    function AddStudentButtonContent() {
        const addStudent = async () => {
            try{

                const res: SingleResult<any> = await addStudentToClassHandler(classClickId, selectedStudentIdList);

                if (res.code === 200) {

                    alert("학생 추가/수정이 완료되었습니다.");

                    setModalProps({ ...modalProps, isOpen: false });
                    getClassList();

                }
            }
            catch (e) {
                console.error(e);
            }
        }

        return (
            <InputWrapR $alignItems="center">
                <EllipsisTextColumn style={{padding: '0 0.5rem', width: '20%'}}>{classClickName}</EllipsisTextColumn>
                <SolidPrimaryBtn
                    onClick={addStudent} style={{ marginLeft: 'auto', width: '100%' }}
                    disabled={!studentsWithImages.length}
                >
                    {selectedStudentIdList.student_ids.length}명 등록
                </SolidPrimaryBtn>
            </InputWrapR>
        )
    }
    
    // 엑셀 header style
    const styleHeaderCell = (cell: ExcelJS.Cell) => {
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFC9C9C9" },
        };
        cell.font = {
            size: 12,
            bold: true,
            color: { argb: "ff252525" },
        };
        cell.alignment = {
            vertical: "middle",
        };
        cell.border = {
            top: {style:'thin'},
            left: {style:'thin'},
            bottom: {style:'thin'},
            right: {style:'thin'}
        }
    };
    // 엑셀 content style
    const styleDataCell = (cell: ExcelJS.Cell) => {
        cell.font = {
            size: 12,
            color: { argb: "ff808080" },
        };
        cell.alignment = {
            vertical: "middle",
            horizontal: "left",
        };
        cell.border = {
            top: {style:'thin'},
            left: {style:'thin'},
            bottom: {style:'thin'},
            right: {style:'thin'}
        }
    };

    //폼 양식 다운로드 link 생성
    const createElementLinkForDownload = async (data: (StudentInfo & { image: string })[]) => {

        try {
            // 반에 있는 student_list 꺼내기
            const exportExcelData: ExcelMoveClassStudentInfo[] = data.map((s: (StudentInfo & { image: string })) => {
                
                const newData = {
                    name: aesCBCDecrypt(s.name),
                    id: s.id,
                    image_file: s.image,
                    origin_class_id: s.class_list.length ? s.class_list[0].id : 0,
                    origin_class_name: s.class_list.length ? s.class_list[0].name : "",
                    new_class_id: 0,
                    new_class_name: "",
                    parent_id: s.parent_list.length ? s.parent_list[0].user_id : 0, // 부모 한 명 만
                    parent_name: s.parent_list.length ? aesCBCDecrypt(s.parent_list[0].user_name) : "",
                };
                return newData;
            });

            // 여러 엑셀 시트를 포함하는 하나의 workbook(단위) 생성
            const wb = new ExcelJS.Workbook();

            // 엑셀 sheet 생성
            const sheet = wb.addWorksheet("move_class");

            // 상단 header
            const headerRow = sheet.addRow(excelHeaders);
            headerRow.height = 27; // 헤더 높이
            headerRow.eachCell((cell, colNum) => {
                styleHeaderCell(cell);
                if (colNum === 4 || colNum === 5) sheet.getColumn(colNum).width = 20;
                else sheet.getColumn(colNum).width = 15;
            })

            // 행마다 데이터 삽입 및 스타일 지정
            exportExcelData.forEach(({name, id, parent_name, origin_class_name, new_class_name}) => {
                const rowDatas = [name, id, parent_name, origin_class_name, new_class_name];
                const contentRow = sheet.addRow(rowDatas);

                contentRow.height = 22; // 행 높이
                contentRow.eachCell((cell, colNum) => {
                    styleDataCell(cell);
                    // 마지막 열(이동반)만 수정 가능
                    if (colNum === excelHeaders.length) {
                        cell.protection = { locked: false };
                        cell.font = { color: { argb: 'ff252525' } };
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFC6E0B4" },
                        };
                    }
                });
            });

            // 나머지 열은 수정 불가
            sheet.protect('aischool_protect', {
                selectLockedCells: true,
                selectUnlockedCells: true,
            })

            // 파일 생성
            const xlsxData = await wb.xlsx.writeBuffer();
            const blob = new Blob([xlsxData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, '반 일괄 이동.xlsx');

        }
        catch(e){
            console.error(e);
            alert("양식 다운로드에 실패했습니다.");
        }
    }

    // 엑셀 반 일괄 이동 모달
    const ExcelMoveClassContent = (): JSX.Element => {
        
        const handleExcelUpload = () => {
            excelInputRef.current?.click();
        }
        return (
            <FlexWrapC $gap="1rem">
                <FlexWrapR>
                    <InputWrapC>
                        <label className="required_value">1. 엑셀 양식 다운로드</label>
                        {/*엑셀 폼 양식 다운로드*/}
                        <SolidPrimarySubBtn onClick={() => {createElementLinkForDownload(studentsWithImages)}}>
                            양식 다운로드
                        </SolidPrimarySubBtn>
                    </InputWrapC>
                    <InputWrapC>
                        <label className="required_value">2. 엑셀 파일 업로드</label>
                        <UploadBtn onClick={handleExcelUpload}>
                            <label>파일 선택</label>
                            <input type="file" name="excel_file" accept=".xlsx, .xls, .csv"
                                onChange={handleExcelChange} ref={excelInputRef} style={{ display: "none" }} />
                            <span>{ uploadExcelFileName }</span>
                        </UploadBtn>
                    </InputWrapC>
                </FlexWrapR>
                <label>3. 반 이동될 학생 목록</label>
                <p style={{marginTop: '-0.75rem'}}>
                    <span className="text-red">* 이동할 반이 없다면 [신규 반 등록]을 먼저 진행해주세요.</span>
                    <span className="text-red"> / 등록되어 있는 반을 정확하게 입력해 주세요.</span>
                </p>
                <p style={{marginTop: '-0.75rem'}}>
                    <span style={{marginRight: '0.5rem', color: colors.gray}}>총({excelMoveClassList.length})</span>
                    <span style={{marginRight: '0.5rem', color: colors.primary}}>반 이동({excelMoveClassList.filter(d => d.exist_class && d.new_class_name && d.new_class_name !== d.origin_class_name).length})</span>
                    <span style={{marginRight: '0.5rem', color: colors.red}}>반 없음({excelMoveClassList.filter(d => !d.exist_class).length})</span>
                </p>
                {/* 엑셀 학생 정보 */}
                { excelMoveClassList.length > 0 &&
                    <ListContentWrap style={{gap: '0.5rem', height: 'calc(100% - 1.25rem - 0.5rem)'}}>
                        <div className="list-one-wrap h100">
                            <div className="list-table">
                                <div>
                                    <nav className="list-table-header">
                                        <div className="w-12">사진</div>
                                        <FlexGrow className="w-15">이름</FlexGrow>
                                        <div className="w-12">고유번호</div>
                                        <FlexGrow className="w-15">학부모</FlexGrow>
                                        <FlexGrow className="w-15">기존 반</FlexGrow>
                                        <FlexGrow className="w-15">이동 반</FlexGrow>
                                        <div className="w-12">결과</div>
                                    </nav>
                                    {excelMoveClassList.map((excelData: ExcelMoveClassStudentInfo & {exist_class: boolean}, index) => 
                                        <TableColumn>
                                            <RoundImageContainer className="w-12">
                                                <RoundBigImage src={excelData.image_file} alt="profile"/>
                                            </RoundImageContainer>
                                            <FlexGrow className="w-15">
                                                <EllipsisTextColumn>{excelData.name}</EllipsisTextColumn>
                                            </FlexGrow>
                                            <div className="w-12">{ excelData.id }</div>
                                            <FlexGrow className="w-15">
                                                <EllipsisTextColumn>{excelData.parent_name}</EllipsisTextColumn>
                                            </FlexGrow>
                                            <FlexGrow className="w-15">
                                                <EllipsisTextColumn>{excelData.origin_class_name}</EllipsisTextColumn>
                                            </FlexGrow>
                                            <FlexGrow className="w-15">
                                                <EllipsisTextColumn
                                                    style={{
                                                        color: `${!excelData.exist_class ? colors.red : (excelData.new_class_name && excelData.new_class_name !== excelData.origin_class_name)
                                                            ? colors.primary : colors.gray}`,
                                                        fontWeight: '600'
                                                    }}>
                                                    {excelData.new_class_name || excelData.origin_class_name}
                                                </EllipsisTextColumn>
                                            </FlexGrow>
                                            <div className="w-12">
                                                {(excelData.exist_class && successMoveClass[index] === 's') && <span style={{ color: colors.primary }}>성공</span>}
                                                {(!excelData.exist_class || successMoveClass[index] === 'f') && <span style={{color: colors.red}}>실패</span>}
                                            </div>
                                        </TableColumn>
                                    )}
                                </div>
                                {isUpload && <UploadingComponent><UploadLoading /></UploadingComponent> }
                            </div>
                        </div>
                    </ListContentWrap>
                }
            </FlexWrapC>
        );
    }
    
    //엑셀 파일 업로드 함수
    const handleExcelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        
        try {

            const file = e.target.files ? e.target.files[0] : null;

            if (!file) {
                // excel/excel 내용 초기화
                setExcelFile(null);
                setExcelMoveClassList([]);
                setMoveClassList([]);
            }
            else {
                
                //엑셀 파일 저장
                setExcelFile(file);

                //엑셀 파일 읽기
                const reader = new FileReader();
                reader.onload = (event) => {
                    const data = event.target?.result;
                    if (data) {
                        const workbook = XLSX.read(data, { type: 'binary' });
    
                        //첫번째 시트 이름
                        const firstSheetName = workbook.SheetNames[0];
    
                        //첫번째 시트 데이터
                        const worksheet = workbook.Sheets[firstSheetName];
    
                        //첫번째 시트의 총 데이터-header 포함
                        const objectData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        
                        // 데이터가 아무것도 없는 경우
                        if (objectData.length === 0) {
                            alert("엑셀 파일에 반 이동될 학생 정보가 없습니다.");
                            setExcelFile(null);
                            setExcelMoveClassList([]);
                            return;
                        }
    
                        //허용되는 헤더 필드
                        const allowedHeaderList = excelHeaders;
                        //첫번째 row의 인덱스 위치를 저장하기 위한 map
                        const headerIndexMap = new Map<string, number>();
                        //첫번째 row는 엑셀의 header
                        const excelFirstRows: any = objectData[0];
                        
                        //헤더 필드의 위치를 저장
                        if (excelFirstRows && typeof excelFirstRows === "object") {
                            
                            // excelHeaders를 순회하여 헤더 필드가 존재하는지 확인
                            for (let i = 0; i < excelFirstRows.length; i++) {
                                excelHeaders.forEach((header, index) => {
                                    if (excelFirstRows[i] === header) {
                                        headerIndexMap.set(allowedHeaderList[index], i);
                                    }
                                });
                            }
                        }
                        
                        // 데이터는 있으나 일치하는 헤더 행이 5개 모두 존재하지 않을 경우
                        if (headerIndexMap.size !== 5) {
                            alert("파일 확인 후 다시 등록해주세요.");
                            setExcelFile(null);
                            setExcelMoveClassList([]);
                            setUploadExcelFileName("");
                            return;
                        }
    
                        //첫번째 row는 제거
                        objectData.shift();

                        // 작성한 엑셀 내 있는 반 - 반 이동 시 특정 반에 학생이 없어지는 경우 해당 반에는 학생이 없다는 걸 전역변수에 전달해줘야함
                        const beforeClassList: number[] = [];
    
                        // Excel 학생 정보
                        const getExcelClassStudentList: any[] = objectData.map((data: any) => {
                            const nameIndex = headerIndexMap.get(allowedHeaderList[0]);
                            const idIndex = headerIndexMap.get(allowedHeaderList[1]);
                            const parentNameIndex = headerIndexMap.get(allowedHeaderList[2]);
                            const originClassIndex = headerIndexMap.get(allowedHeaderList[3]);
                            const newClassIndex = headerIndexMap.get(allowedHeaderList[4]);

                            // 인덱스가 올바르게 존재하는지 확인
                            if (nameIndex !== 0 || idIndex !== 1 || parentNameIndex !== 2 ||
                                originClassIndex !== 3 || newClassIndex !== 4) {
                                console.error("헤더 인덱스를 찾을 수 없습니다.");
                                alert("파일 확인 후 다시 등록해주세요.");
                                setExcelFile(null);
                                setExcelMoveClassList([]);
                                return null;
                            }
                            
                            // 학생 이름을 삭제한 경우 제외
                            if (!data[nameIndex]) return null;
                            // 학생 ID를 삭제한 경우 제외
                            if (!data[idIndex]) return null;
                            // 기존반도 없고, 이동반도도 입력 안한 경우 제외
                            if (!data[originClassIndex] && !data[newClassIndex]) return null;
                            
                            // 이동반 ID 찾기
                            let newClassId = 0;
                            // 이동반 미입력 시 이동을 안한다는 의미인데, 현재반에서 삭제될 수 있으므로 기존반 id 가져와야함
                            let isExistClass;
                            if (data[newClassIndex]) {
                                isExistClass = classList.find((c: ClassInfo) => c.name === data[newClassIndex]);
                            }
                            else {
                                isExistClass = classList.find((c: ClassInfo) => c.name === data[originClassIndex]);
                            }

                            // 등록되어 있는 반인 경우
                            if (isExistClass) {
                                newClassId = isExistClass.id;
                            }

                            // 입력한 이동반이 실제 db에 없는 경우 제외
                            // if (!newClassId) return null;

                            // 기존 반 push
                            const beforeClass = classList.find((c: ClassInfo) => c.name === data[originClassIndex]);
                            if (beforeClass) {
                                const bool = beforeClassList.some(c => c === beforeClass.id);
                                if (!bool) beforeClassList.push(beforeClass.id);
                            }

                            // 학생사진
                            const studentId = data[idIndex] ? data[idIndex] : null;
                            let studentImage = "";
                            if (studentId) {
                                const isExist = studentsWithImages.find((s: StudentInfo & { image: string }) => s.id === studentId);
                                studentImage = isExist?.image ? isExist.image : "";
                            }

                            return {
                                name: data[nameIndex],
                                id: data[idIndex],
                                image_file: studentImage,
                                parent_name: data[parentNameIndex],
                                origin_class_name: data[originClassIndex],
                                new_class_id: newClassId,
                                new_class_name: data[newClassIndex],
                                exist_class: newClassId ? true : false,
                            };
                        }).filter((excelStudent) => excelStudent !== null); // null 값은 필터링하여 제외

                        // 엑셀 파일 유효성 검사 후 class_id 순서로 정렬
                        const showClassStudentList = [...getExcelClassStudentList].sort((a, b) => a.new_class_id - b.new_class_id);
                        setExcelMoveClassList(showClassStudentList);

                        // API용으로 class_id, student_ids 분류
                        const reqDatas: { id: number, student_ids: number[] }[] = [];

                        // new_class_id === 0인 경우 기존반으로 넣어놓기
                        showClassStudentList.forEach(list => {
                            const { new_class_id, id, origin_class_name } = list;
                            const classId = new_class_id === 0 
                                ? classList.find(data => data.name === origin_class_name)?.id 
                                : new_class_id;
                        
                            if (classId !== undefined) {
                                const existClass = reqDatas.find(data => data.id === classId);
                        
                                if (existClass) {
                                    // 기존 student_ids에 추가
                                    existClass.student_ids = [...existClass.student_ids, id];
                                } else {
                                    // 새로운 객체 생성하여 추가
                                    reqDatas.push({ id: classId, student_ids: [id] });
                                }
                            }
                        });


                        // 학생이 아무도 없는 반 추출
                        const temp = reqDatas.map(data => data.id);
                        const noStudentClass = beforeClassList.filter(c => !temp.includes(c));
                        if (noStudentClass.length) {
                            const noStudentClassdata = noStudentClass.map(c => {
                                return { id: c, student_ids: [] };
                            })
                            reqDatas.push(...noStudentClassdata);
                        }
                        
                        setMoveClassList(reqDatas);
                        setSuccessMoveClass([]);
                    }
                };

                setUploadExcelFileName(file.name);
                // 파일 업로드가 끝나고 초기화해야 동일한 파일 이름으로 재업로드 가능
                reader.onloadend = () => {
                    e.target.value = "";
                };
    
                reader.readAsBinaryString(file);

            }

        }
        catch(e){
            console.error(e);
        }
    };
    
    function ExcelMoveClassButton() {

        //서버에 엑셀 업로드 요청
        const uploadFilesHandler = async () => {
            if(!excelFile){
                alert("엑셀 파일을 선택해주세요.");
                return;
            }
            try {
                // 서버에 반 이동 요청 시작
                setIsUpload(true);

                const updateData: ClassInfo[] = [];

                // 없는 반을 입력한 학생에 대해서는 미리 '실패' 결과 보여주기
                setSuccessMoveClass(Array(excelMoveClassList.filter(list => !list.exist_class).length).fill("f"));

                // API 전송
                for (let i = 0; i < moveClassList.length; i++) {

                    const { id, student_ids } = moveClassList[i];
                    // 있는 반일 때
                    if (id !== 0) {
                        
                        const res: SingleResult<any> = await updateStudentClassExcelHandler(id, { student_ids });
    
                        if (res.code === 200) updateData.push(res.data);
    
                        setSuccessMoveClass(prev => {
                            const newResult = [...prev];
                            const resultToAdd = res.code === 200 ? Array(student_ids.length).fill("s") : Array(student_ids.length).fill("f");
                            
                            return newResult.concat(resultToAdd); // 새 결과 추가
                        });
                    }
                }
                
            }
            catch (e){
                console.error(e);
                alert("반 일괄 이동에 실패했습니다, 다시 시도해주세요.");
            }
            finally {
                setIsUpload(false);
            }
        }

        return (
            <SolidPrimaryBtn onClick={uploadFilesHandler} disabled={(isUpload || !excelFile)}>
                이동하기({excelMoveClassList.filter(c => c.exist_class).length})
            </SolidPrimaryBtn>
        )
    }


    //반 등록/수정 모달 컨텐츠
    const ClassModalContent = (): JSX.Element => {

        function updateRequestClass(updates: Partial<ClassRequestType>) {
            setRequestClass((prevRequestClass) => ({
                ...prevRequestClass,
                ...updates,
            }));
        }

        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
            const { name, value } = e.target;
            if (name === 'name') {
                const val = value.trimStart().trimEnd().replaceAll("  ", " ");
                updateRequestClass({ name: val });
            }
            else
                updateRequestClass({ [name]: value }); // 상태 업데이트
        };

        const handleColorSelect = (colorName: string) => {
            updateRequestClass({ color_type: colorName }); // 색상 선택 시 상태 업데이트
        };

        const handleChangeOption = (userId: number) => {
            updateRequestClass({ user_id: userId }); // 담임 선생님 선택 시 상태 업데이트
        };

        return (
            <InputWrapC>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">반 이름</label>
                        <input type="text" name="name" onChange={handleInputChange} value={requestClass.name} placeholder="반 이름 입력" disabled={ user_role !== ROLE_DIRECTOR} />
                    </InputWrapC>
                </InputWrap>

                <InputWrap>
                    <InputWrapC>
                        <label>뱃지 색상 지정</label>
                        <ColorListWrap>
                            {colorList.map((color) => {
                                return (
                                    <CircleListBadge
                                        key={color.colorCode}
                                        bgColor={color.colorCode}
                                        checked={requestClass.color_type === color.colorName}
                                        onClick={() => handleColorSelect(color.colorName)}
                                    />
                                );
                            })}
                        </ColorListWrap>
                        <input type="text"
                               value={
                                   requestClass.color_type === "WHITE"
                                       ? colorList.find(color => color.colorName === requestClass.color_type)?.colorCode + " (미지정)"
                                       : colorList.find(color => color.colorName === requestClass.color_type)?.colorCode || ''
                               }
                               name="color_type"
                               readOnly/>
                    </InputWrapC>
                </InputWrap>


                <InputWrap>
                    <InputWrapC>
                        <label>담임 선생님</label>
                        {user_role === ROLE_DIRECTOR ?
                            <SelectOption optionData={selectOptionTeachers}
                                        onChange={(userId: number) => handleChangeOption(userId)}
                                        defaultValue={requestClass.user_id} />
                            :
                            <input type="text" value={aesCBCDecrypt(name)} disabled />
                        }
                    </InputWrapC>
                </InputWrap>

                <InputWrap>
                    <InputWrapC>
                        <label>반 소개 제목</label>
                        <input type="text" value={requestClass.title} onChange={handleInputChange} name="title" placeholder="반 소개 제목 입력"/>
                    </InputWrapC>
                </InputWrap>

                <InputWrap>
                    <InputWrapC>
                        <label>반 소개 내용</label>
                        <textarea onChange={handleInputChange} value={requestClass.content} name="content" placeholder="반 소개 내용 입력"/>
                    </InputWrapC>
                </InputWrap>
            </InputWrapC>
        )
    }

    //반 등록/수정 모달 하단 버튼
    function ButtonModalContent() {
        return (
            modalProps.type === "classCreate" ?
                <SolidPrimaryBtn onClick={validateClassForm}>등록 완료</SolidPrimaryBtn>
                : <SolidPrimaryBtn onClick={validateClassForm}>수정 완료</SolidPrimaryBtn>
        )
    }

    // 반 삭제 API 호출
    const handleDeleteClass = async (classId:number):Promise<void> => {

        const confirm:boolean = window.confirm("반 삭제 시 해당 반에 등록되어 있는 학생들은 '반 미정'인 상태로 수정됩니다. 해당 반을 삭제하시겠습니까?");
        if(!confirm){
            return;
        }

        const res:CommonResult = await removeClassHandler(classId);
        if(res.code === 200){
            alert("반 삭제가 완료되었습니다.");

            setModalProps({ ...modalProps, isOpen: false });
            getClassList();

        }
        else{
            alert(res.message);
        }
    }

    // 학생추가/수정 모달 하단에서 보이는 반 이름
    useEffect(() => {
        if (!modalProps.isOpen) {
            setClassClickName("");
        }
    }, [modalProps.isOpen]);
    
    useEffect(() => {
        // 반 일괄 이동 후 새로고침용
        if (!modalProps.isOpen) {
            getClassList();
        }
    }, [modalProps.isOpen]);

    return (
        loading ? <Loading />
        : (
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">반 관리</p>
                        <div className="button-wrap">
                        {user_role === ROLE_DIRECTOR &&
                            <>
                                <SolidPrimaryBtn onClick={() => {openModal('classCreate');initRequestClass();}}>
                                    신규 반 등록
                                </SolidPrimaryBtn>
                                <NoLinePrimaryBtn onClick={() => { initExcel(); openModal('excelMoveClass'); }} disabled={studentsWithImages.length < 1}>반 일괄 이동</NoLinePrimaryBtn>
                            </>
                        }
                    </div>
                </PageHeaderTitleButtonStyle>

                <PageArticleWrap>
                    <article className="list-content-container">
                        <div className="article-header">
                            <p>
                                <span className="article-header-title">반 정보({classList.length})</span>
                            </p>
                        </div>
                        <ListContentWrap style={{height: 'calc(100% - 1.25rem)'}}>
                            {classList.length === 0 ? (
                                <NoDataWrap>
                                    <NoDataWithImageText text={user_role === ROLE_TEACHER ? NoTeamClassDataText : NoClassDataText} />
                                </NoDataWrap>
                            ) : (
                                <ClassListTableViewer
                                    classList={classList}
                                    openModal={openModal}
                                    changeRequestClassHandler={changeRequestClassHandler}
                                    handleDeleteClass={handleDeleteClass}
                                />
                            )}
                        </ListContentWrap>
                    </article>
                </PageArticleWrap>
                {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
                <DefaultModalComponent
                    isOpen={modalProps.isOpen}
                    content={
                        (modalProps.type === "classCreate" || modalProps.type === "classModify") ? ClassModalContent()
                            : modalProps.type === "excelMoveClass" ? ExcelMoveClassContent(): AddStudentModalContent()}
                    button={
                        (modalProps.type === "classCreate" || modalProps.type === "classModify") ? ButtonModalContent()
                            : modalProps.type === "excelMoveClass" ? ExcelMoveClassButton() : AddStudentButtonContent()}
                    type={modalProps.type}
                    isClose={modalProps.isClose}
                    title={modalProps.title} />
            </>
        )
    )
}
